module.exports = __webpack_public_path__ + "static/media/1POLICY33.1bc2c3b7.jpg";